import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const PAGE_CONTENT = {
    0: () => (
        <>
            <h3>Introduction</h3>
            <p>Please read this brief carefully and answer the questions. We understand that some of this may be very simple. We are not teaching you to be the professional photographers we hired. There is just specific information pertaining to this event that we need you to understand. Thanks.</p>

            <h3>What to Bring</h3>
            <p>Spare batteries NB NB, camera cover, umbrella/cabana, raincoat, sunscreen, bug spray, folding chair, food, water. Bright "Official Photographer" bib if you have one (or try get from the organiser on the day)</p>
            <p>The event goes ahead rain or shine — come prepared.</p>
            <p>There are no allotted breaks — take them as needed but try not to miss too many participants.</p>

            <hr />

            <h3>Camera Setup — Do This Now or the Day Before</h3>
            <p>Lens: Use your 70–200mm or 100–400mm. Finish photographer should use a 24–70mm.</p>
            <ol>
                <li>Shoot JPEGs — NOT RAW</li>
                <li>We aim to have photos between 1-3 megs in size. The lower the size the more time this will save you later. We absolutely cannot have photos bigger than 5megs and obviously we don't want them too low. Adjust the quality/fineness setting on your camera to achieve this. It is most likely the standard/medium setting not fine. Test by taking a shot and checking the file size on your SD card. It should be around 1-3 megs (definitely not over 4.5megs for a test). If you don't get this right and we have to load to Lightroom first, we will be unable to deliver photos on time and fail to meet our obligations to the event organiser.</li>
                <li>Set the correct time on your camera. Ensure AM or PM or 24:00hr mode and adjust for daylight saving if applicable.</li>
            </ol>
        </>
    ),
    2: () => (
        <>
            <h3>Shooting Instructions on the Day</h3>
            <p>Settings: Aim for 1/1000s shutter speed, f2.8–4 aperture, auto ISO. As the day gets brighter you may need to increase shutter speed as ISO cannot drop below 100.</p>
            <ol>
                <li>Get the composition right — photos will be uploaded without editing.</li>
                <li>Accommodate requests for group photos but avoid bottlenecks and missing other competitors.</li>
                <li>Shoot landscape mode</li>
            </ol>

            <h3>The #1 priority: get at least one photo of every single person</h3>
            <p>Ideally 2–3 photos per person. With ~3,000 competitors, aim for 6,000–9,000 photos total (the Finish photographer will shoot considerably fewer, but no photographer should shoot fewer than ~4,000).</p>

            <h3>Do NOT use rapid burst mode</h3>
            <p>Every photo in a sequence must be appreciably different — meaning someone would want to buy multiple photos because they show different things (e.g. one shows the full body, one shows just the torso).</p>
            <p>Enjoy yourself and add to the good vibes of the event! You are representing Foam Fest and Bossfotos — please be friendly to everyone.</p>
        </>
    ),
    4: () => (
        <>
            <h3>Loading Instructions</h3>
            <p>Bossfotos key selling point is the speed with which we get the photographs to customers. Loading is as critical as taking the photographs. This is why we don't edit photographs, keep the photos small and why we allocate $100 of your remuneration to loading. This is also a fixed fee for your time. If you get these instructions right you will be finished within an hour.</p>
            <p>Photos must be loaded immediately after the event — ideally at the event venue, or at home if you leave within about an hour. We expect you to be able to load the photos within 1-2 hours of the event finishing and our absolute drop-dead time is completed within 4 hours in exceptional circumstances. We will deduct pay if this doesn't happen so, if you feel this will not be achievable, let us know now and we can arrange for someone to load yours for $50.</p>

            <h3>Technical requirements:</h3>
            <ul>
                <li>Minimum 20Mbps stable upload speed</li>
                <li>Load from a connection that won't be throttled or capped</li>
                <li>Use Chrome in Incognito mode</li>
                <li>Preferably use a LAN cable attached to your router</li>
                <li>Have a backup plan if your first option fails. Ie work in pairs, have a spare computer, have a second venue to go to if your wifi fails</li>
            </ul>
            <p>Before you start loading, message the whatsapp chat with how many photos you are loading and when you will begin.</p>

            <h3>Gallery setup:</h3>
            <p>We will pre-load 3 galleries per photographer. Divide your total photos into 3 approximately equal batches by time taken. No single gallery should exceed 3,000–4,000 photos (e.g. if you shot 6,000 photos, load 3 galleries of ~2,000 each).</p>

            <h3>Loading steps:</h3>
            <ol>
                <li>Login to <a href="https://www.bossfotos.com/photographer/map" target="_blank" rel="noopener noreferrer">https://www.bossfotos.com/photographer/map</a> with the login details on the whatsapp group</li>
                <li>Find the 3 galleries matching your obstacle/name</li>
                <li>Click the "actions" dots next to the gallery and select "add photos", then load that batch to the gallery. You can open 3 tabs in your browser and load all 3 galleries simultaneously — however start each one 10 minutes apart rather than all at once.</li>
                <li>Maximum file size: 5MB (you should have already preset to between 1-3mb — if larger you will need to resize in Lightroom, which will be a significant waste of time. Only resize photos that are too big.)</li>
                <li>Never delete a gallery — if you have any issues, contact us on this WhatsApp</li>
                <li>Once loaded, confirm that the number of photos loaded matches the number you shot — then DM the whatsapp group to confirm loading has finished.</li>
            </ol>
            <p>Make absolutely sure you the number of photographs you have taken matches the photos loaded.</p>

            <h3>Errors/Troubleshooting</h3>
            <p>If you get an upload error, let the other tabs finish loading first and then return to the problem gallery. It is most likely your WiFi being throttled, so it will be better to retry once you don't have 3 tabs open. Then edit the gallery and reload ALL photos — the system will not create duplicates. Never delete a gallery or start from scratch. If in doubt, contact us on the WhatsApp group and we will help you.</p>
        </>
    ),
}

export const GuidePage = ({ pageIndex }) => {
    const classes = useStyles()
    const Content = PAGE_CONTENT[pageIndex]

    return (
        <div className={classes.page}>
            <div className={classes.body}>
                {Content && <Content />}
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    page: {
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: 32,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    body: {
        fontSize: 14,
        lineHeight: 1.7,
        color: '#444',
        fontWeight: 400,
        '& h3': {
            fontSize: 16,
            fontWeight: 700,
            color: '#333',
            margin: '24px 0 12px 0',
            '&:first-child': {
                marginTop: 0,
            },
        },
        '& p': {
            margin: '0 0 12px 0',
            fontSize: 14,
            fontWeight: 400,
        },
        '& em': {
            fontStyle: 'normal',
        },
        '& ul': {
            paddingLeft: 24,
            margin: '0 0 12px 0',
        },
        '& ol': {
            paddingLeft: 24,
            margin: '0 0 12px 0',
        },
        '& a': {
            color: '#1976d2',
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        '& li': {
            marginBottom: 10,
            fontSize: 14,
            fontWeight: 400,
        },
        '& hr': {
            border: 'none',
            borderTop: '1px solid #e0e0e0',
            margin: '24px 0',
        },
    },
})
